import { characterLogic, heroLogic, hitpointsLogic, monsterLogic, movementLogic } from "./adventure";
import { AnyLogicState, LogicKey, LogicStateByKey } from "./all";
import { doorLogic } from "./door";
import { renderLogic } from "./graphics";
import { managementLogic } from "./management";
import { visibilitySourceLogic } from "./visibility";
import { Shape } from "@kosmod/pancake";

export const Logic = {
  render: renderLogic,
  visibility: {
    source: visibilitySourceLogic,
    door: doorLogic,
  },
  adventure: {
    hitpoints: hitpointsLogic,
    character: characterLogic,

    monster: monsterLogic,
    hero: heroLogic,

    movement: movementLogic,
  },
  managementLogic,

  /**
   * From a list of Logic States, find an active state by key
   * @param key 
   * @param list 
   * @returns 
   */
  find<T extends LogicKey>(key: T, list: ReadonlyArray<AnyLogicState>): LogicStateByKey[T] | null {
    return list.find((state): state is LogicStateByKey[T] => {
      return state.key === key && state.enabled;
    }) || null
  },
  create<T extends LogicKey>(key: T, data: LogicStateByKey[T]["data"]): LogicStateByKey[T] {
    return { key, data, enabled: true } as LogicStateByKey[T]
  },
  clone<T extends Logic.Any>(logic: T): T {
    return { ...logic, data: { ...logic.data } }
  },

  Any: AnyLogicState
}

export namespace Logic {
  export type Type = {
    key: string,
    state: Shape.Any,
  }

  export type StateOf<T extends Type> = { key: T["key"], data: Shape.Type.Of<T["state"]>, enabled: boolean };

  export type Key = LogicKey;
  export type StateByKey = LogicStateByKey;
  export type Any = StateByKey[Key];
}
